import { apiCall } from './gqlClient';

const GETPENDINGCUSTOMERS_QUERY = `
  query getPendingCustomers {
    getPendingCustomers
  }`;

export const getPendingCustomersApiCall = async () => apiCall({ query: GETPENDINGCUSTOMERS_QUERY, variables: {}});

const CHECKFORPENDINGCUSTOMERS_QUERY = `
  query checkForPendingCustomers {
    checkForPendingCustomers
  }`;

export const checkForPendingCustomersApiCall = async () => apiCall({ query: CHECKFORPENDINGCUSTOMERS_QUERY, variables: {}});

const APPROVECUSTOMER_QUERY = `
  mutation approveCustomer($userId: Int!) {
    approveCustomer(userId: $userId)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const approveCustomerApiCall = async ({userId}, fragments = null) => apiCall({ query: APPROVECUSTOMER_QUERY, variables: {userId}, fragments });
